import { selectResponseData } from 'util/selector/axiosSelector';

import { AxiosInstance } from 'axios';

import {
  CreateGlobalQuestionLibraryCategoryDto,
  CreateGlobalQuestionLibraryQuestionDto,
  GlobalQuestionLibraryCategoryDto,
  GlobalQuestionLibraryCategoryModel,
  GlobalQuestionLibraryChangesPageDto,
  GlobalQuestionLibraryChangesPageModel,
  GlobalQuestionLibraryQuestionDto,
  GlobalQuestionLibraryQuestionModel,
  UpdateGlobalQuestionLibraryCategoryDto,
  UpdateGlobalQuestionLibraryQuestionDto,
} from './dto/GlobalQuestionLibrary.dto';

export type FetchGlobalQuestionLibraryChangesParams = {
  page?: number;
  limit?: number;
  questionId?: string;
};

export class GlobalQuestionLibraryApi {
  constructor(private client: AxiosInstance) {}

  fetchQuestions(): Promise<GlobalQuestionLibraryQuestionModel[]> {
    return this.client
      .get<{ data: GlobalQuestionLibraryQuestionDto[] }>('/api/v1/question-library/questions')
      .then((response) => selectResponseData(response).data);
  }

  fetchCategories(): Promise<GlobalQuestionLibraryCategoryModel[]> {
    return this.client
      .get<{ data: GlobalQuestionLibraryCategoryDto[] }>('/api/v1/question-library/categories')
      .then((response) => selectResponseData(response).data);
  }

  fetchChanges(
    params: FetchGlobalQuestionLibraryChangesParams = {},
  ): Promise<GlobalQuestionLibraryChangesPageModel> {
    const { page, limit, questionId } = params;

    return this.client
      .get<GlobalQuestionLibraryChangesPageDto>('/api/v1/question-library/changes', {
        params: { page, limit, 'filter[questionId]': questionId },
      })
      .then((response) => selectResponseData(response));
  }

  createQuestion(
    payload: CreateGlobalQuestionLibraryQuestionDto,
  ): Promise<GlobalQuestionLibraryQuestionModel> {
    return this.client
      .post<{
        data: GlobalQuestionLibraryQuestionDto;
      }>('/api/v1/question-library/questions', payload)
      .then((response) => selectResponseData(response).data);
  }

  updateQuestion(
    id: string,
    payload: UpdateGlobalQuestionLibraryQuestionDto,
  ): Promise<GlobalQuestionLibraryQuestionModel> {
    return this.client
      .put<{
        data: GlobalQuestionLibraryQuestionDto;
      }>(`/api/v1/question-library/questions/${id}`, payload)
      .then((response) => selectResponseData(response).data);
  }

  createCategory(
    payload: CreateGlobalQuestionLibraryCategoryDto,
  ): Promise<GlobalQuestionLibraryCategoryModel> {
    return this.client
      .post<{
        data: GlobalQuestionLibraryCategoryDto;
      }>('/api/v1/question-library/categories', payload)
      .then((response) => selectResponseData(response).data);
  }

  updateCategory(
    id: string,
    payload: UpdateGlobalQuestionLibraryCategoryDto,
  ): Promise<GlobalQuestionLibraryCategoryModel> {
    return this.client
      .patch<{
        data: GlobalQuestionLibraryCategoryDto;
      }>(`/api/v1/question-library/categories/${id}`, payload)
      .then((response) => selectResponseData(response).data);
  }
}
